jQuery(document).ready(function(){
  jQuery('.magnet-slider.owl-carousel').owlCarousel({
    items:1,
    loop:true,
    nav:true,
    autoplayHoverPause: true
  });
//   jQuery('.grid-uniform.owl-carousel').owlCarousel({
//     items: 4,
//     loop:true,
//     center:true
//   });
  jQuery('.grid-uniform.owl-carousel').owlCarousel({
    loop:true,
    margin:20,
    //center:true,    
    autoplay:true,
    autoplayTimeout:3000,
    smartSpeed:1000,
    autoplayHoverPause: true,
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
          	stagePadding:40,
          	dots:false
        },        
        1024:{
            items:2,
          	stagePadding:120
        }
    }
	});
});
